import uniqueid from 'lodash.uniqueid';

export default {

  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: () => uniqueid('baseInput_')
    },
    infoMessage: {
      type: String,
      default: null
    },
    modelValue: {
      default: null
    },
    noSelectionMessage: {
        type: String,
        default: null
    }
  },
  computed: {
    labelText() {
      return this.label;
    },
    // Shared "Select a {Label}" prompt used by the select components for their
    // empty/placeholder option. Null when there's no label so callers can fall
    // back to their own blank text / the underlying component default.
    selectPrompt() {
      return this.noSelectionMessage ?? (this.label ? `Select a ${this.label}` : null);
    },
  },
  methods: {
    handleInput(e) {
      this.$emit("update:modelValue", e);
      this.$emit("input", e); // backwards compat for any direct @input listeners
    }
  }
};